import { BILLING_ACTIONS } from "../constants/constant";

export function setBillingOverview(billingOverviewData) {
  return {
    type: BILLING_ACTIONS.SET_BILLING_OVERVIEW,
    payload: billingOverviewData,
  };
}
